/**
 * API Configuration
 * Centralized configuration for API base URL and related settings
 */

export const API_CONFIG = {
	baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:8001/api",
	timeout: 30000,
} as const;

// Token storage keys
export const TOKEN_KEYS = {
	access: "access_token",
	refresh: "refresh_token",
} as const;

// Token management utilities
export const tokenStorage = {
	getAccessToken: (): string | null => {
		return localStorage.getItem(TOKEN_KEYS.access);
	},

	getRefreshToken: (): string | null => {
		return localStorage.getItem(TOKEN_KEYS.refresh);
	},

	setTokens: (accessToken: string, refreshToken: string): void => {
		localStorage.setItem(TOKEN_KEYS.access, accessToken);
		localStorage.setItem(TOKEN_KEYS.refresh, refreshToken);
	},

	clearTokens: (): void => {
		localStorage.removeItem(TOKEN_KEYS.access);
		localStorage.removeItem(TOKEN_KEYS.refresh);
	},
};
